export const LOAD_KPIS = "LOAD_KPIS";
export const LOAD_KPIS_SUCCESS = "LOAD_KPIS_SUCCESS";
export const LOAD_KPIS_ERROR = "LOAD_KPIS_ERROR";
